import React, { Component } from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components';

import Header from '../components/Header';

import '../css/reset.css';
import '../css/prism.css';
import icon from '../assets/logo/icon.svg';

const Background = styled.div`
  background-color: ${props => props.location ? '#FAFBFC' : '#FFF'};
  min-height: 100vh;
`;

class Template extends Component {

  render() {
    const { location, children, data: { allContentfulCategory: { edges } } } = this.props;

    const onTarget = location.pathname === '/' || location.pathname === '/stories' || location.pathname === '/engineering' || location.pathname === '/company' || location.pathname === '/product';

    return (
      <Background
        location={onTarget}
      >
        <Header 
          location={location}
          categories={edges}
        />
        {children()}
        <div style={{padding: 100}}/>
      </Background>
    )
  }
}

Template.propTypes = {
  children: React.PropTypes.func,
  location: React.PropTypes.object,
  route: React.PropTypes.object,
}

export default Template;

export const templateQuery = graphql`
  query TemplateQuery {
    allContentfulCategory {
      edges {
        node {
          name
        }
      }
    }
  }
`;


// WEBPACK FOOTER //
// ./src/layouts/index.js